<template>
	<div class="qualification-new">
		<!-- 广告位--start -->
		<div class="poster-container">
			<img src="@/assets/poster/poster_01.jpg" alt="启程建筑梦想，从资资质重新核定开始" />
		</div>
		<!-- 广告位--end -->

		<!-- 资质重新核定诊断记录--start -->
		<div class="diagnosis-record-container">
			<div class="diagnosis-record-content">
				<h3 class="moudleDefaultTitle">资质重新核定诊断记录</h3>

				<div class="record-group">
					<div class="section-sub-title">
						<h4>全部</h4>
						<router-link to="/qualification/diagnosticRecordsMore/CXHD" class="section-sub-title_more">
							更多
							<i class="el-icon-arrow-right"></i>
						</router-link>
					</div>

					<!-- 展示诊断记录 -->
					<diagnostic-records ref="diagnosticRecords" matters-type="CXHD"></diagnostic-records>
				</div>
			</div>
		</div>
		<!-- 资质重新核定诊断记录--end -->

		<!-- 解锁诊断服务--start -->
		<div class="diagnostic-service-container">
			<div class="diagnostic-service-content">
				<img src="@/assets/qualificationService/diag-service.jpg" alt="解锁诊断服务" />
			</div>
		</div>
		<!-- 解锁诊断服务--end -->

		<!-- 资质重新核定诊断流程--start -->
		<div class="process-container">
			<div class="process-content">
				<h3 class="moudleDefaultTitle">资质重新核定诊断流程</h3>

				<div class="process-main">
					<div class="process-steps">
						<div v-for="(item, index) in processList" :key="index" class="step-item">
							<span class="step-num">{{ String(index + 1).padStart(2, '0') }}</span>
							<div>
								<p class="step-title">{{ item.title }}</p>
								<p class="step-desc">{{ item.desc }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 资质重新核定诊断流程--end -->

		<!-- 重新核定资质诊断--start -->
		<div class="selection-container">
			<div class="selection-content">
				<h3 class="moudleDefaultTitle">重新核定资质诊断</h3>

				<div class="selection-box">
					<div class="qualification-type-switch">
						<div class="switch-item" :class="{ active: qualificationType === 'existing' }" @click="handleSwitchType('existing')">
							现有资质
						</div>
						<div
							class="switch-item"
							:class="{ active: qualificationType === 'renewable' }"
							@click="handleSwitchType('renewable')"
						>
							可重新核定资质
						</div>
					</div>

					<!-- 添加温馨提示 -->
					<div class="warm-tips">
						<i class="el-icon-warning-outline tips-icon"></i>
						<div class="tips-content">
							温馨提示：湖北省数字住建政府服务综合平台资质重新核定/延续是对本企业已有资质进行延续和重新核定。建议在现有资质处做诊断。
						</div>
					</div>

					<div v-loading="qualificationLoading">
						<template v-if="qualificationGroups.length">
							<div v-for="(item, index) in qualificationGroups" :key="index" class="category-group">
								<div class="category-title">
									<div class="category-title-inner">{{ item.name }}</div>
								</div>
								<div class="category-options">
									<div ref="optionsContainer" class="options-container" :class="{ 'is-expanded': expandedGroups[index] }">
										<div class="options-row">
											<div v-for="(item1, inedx1) in item.collection" :key="inedx1" class="option-item">
												<el-checkbox
													v-model="item1.selected"
													class="custom-checkbox"
													:disabled="isDisabled(item.name, item1)"
													@change="val => handleCheckboxChange(val, item.name, item1)"
												>
													{{ item1.dictionaryValues }}
												</el-checkbox>
											</div>
										</div>
									</div>

									<!-- 展开/收起按钮 -->
									<div v-if="showExpandButtons[index]" class="expand-btn-wrapper">
										<div class="expand-btn" @click="toggleExpand(index)">
											<span>{{ expandedGroups[index] ? '收起' : '展开更多' }}</span>
											<i class="expand-icon" :class="expandedGroups[index] ? 'is-up' : 'is-down'"></i>
										</div>
									</div>
								</div>
							</div>
						</template>
						<!-- 数据为空 -->
						<empty-content v-else empty-text="暂无资质信息"></empty-content>
					</div>

					<div class="selection-action">
						<button class="cjt-button cjt-button--primary" type="button" @click="handleDiagnoseImmediately">
							<span>立即诊断</span>
							<span class="tag-member tag-member--vip">VIP</span>
						</button>
					</div>

					<!-- 未绑定企业遮罩层 -->
					<nonbind-enterprise v-if="!isHasCompany"></nonbind-enterprise>
				</div>
			</div>
		</div>
		<!-- 重新核定资质诊断--end -->

		<!-- 提交资质诊断材料 -->
		<jr-dialog :visible.sync="diagnosisVisible" title="提交资质诊断材料" width="1400px" top="100px" :append-to-body="true">
			<template v-if="diagnosisVisible" slot="content">
				<!-- 在此处展示已选择资质信息 -->
				<has-selectd-qualification :qualification-info="selectedQualificationInfo"></has-selectd-qualification>

				<!-- 根据所选择的资质来判定属于哪类资质材料维护 -->
				<component
					:is="getComponentBySslCode"
					ref="maintenanceInfo"
					:is-setting="true"
					:is-diagnostic="true"
					:qualification-info="selectedQualificationInfo"
				></component>
			</template>
			<template slot="footer">
				<el-button @click="handleCloseDiagnosis">取 消</el-button>
				<el-button :loading="submitLoading" type="primary" @click="handleSubmitMaterials">提交材料</el-button>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import JrDialog from '@/components/Dialog'
	import DiagnosticRecords from './materialsRecord/diagnosticRecords'
	import SafetyPermitMaintenance from './materialsRecord/safetyPermitMaintenance'
	import ConstructionEnterpriseMaintenance from './materialsRecord/constructionEnterpriseMaintenance'
	import EngineeringSupervisionMaintenance from './materialsRecord/engineeringSupervisionMaintenance'
	import RealEstateDevelopmentMaintenance from './materialsRecord/realEstateDevelopmentMaintenance'
	import NonbindEnterprise from '@/components/NonBind/nonbindEnterprise'
	import HasSelectdQualification from './components/hasSelectdQualification'
	import { mapGetters } from 'vuex'
	import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'
	import { queryCommonDictionary } from '@/api/dictionary/index'
	import { generateDiagnosticResults } from '@/api/certTreasure/diagnosis'

	// 资质重新核定页面
	export default {
		name: 'QualificationReEvaluate',
		components: {
			JrDialog,
			DiagnosticRecords,
			NonbindEnterprise,
			SafetyPermitMaintenance,
			ConstructionEnterpriseMaintenance,
			EngineeringSupervisionMaintenance,
			RealEstateDevelopmentMaintenance,
			HasSelectdQualification
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				processList: [
					{
						title: '选择资质',
						desc: '选择诊断的资质类型',
						imageUrl: require('@/assets/index/process/process-01.png')
					},
					{
						title: '立即诊断',
						desc: '自动带入企业已有条件补充相关材料',
						imageUrl: require('@/assets/index/process/process-01.png')
					},
					{
						title: '诊断结果',
						desc: '给出待调整内容',
						imageUrl: require('@/assets/index/process/process-01.png')
					},
					{
						title: '结果分析',
						desc: '给出调整方案',
						imageUrl: require('@/assets/index/process/process-01.png')
					},
					{
						title: '管家协助',
						desc: '专业管家帮办',
						imageUrl: require('@/assets/index/process/process-01.png')
					}
				],

				// 添加资质类型切换状态
				qualificationType: 'existing', // 默认选中"现有资质"
				// 当前选中的资质类型
				selectedCategoryType: null,
				// 所有证书及对应资质类别
				qualificationGroups: [],
				// 已经选中的资质证书信息，用于诊断结果生成
				selectedQualificationInfo: null,
				// 资质查询loading
				qualificationLoading: false,

				// 控制每个类别的展开状态
				expandedGroups: {},
				// 控制是否显示展开按钮
				showExpandButtons: {},
				// 最大显示高度（3行的高度）
				maxHeight: 213,

				// 资质诊断弹窗
				diagnosisVisible: false,
				submitLoading: false
			}
		},
		computed: {
			...mapGetters(['isHasCompany', 'companyId', 'vipLevel', 'isNormalVip', 'isVip', 'isSVip']),
			// 通过sslCode判断渲染那个证书的材料维护组件
			getComponentBySslCode() {
				const selectOptions = this.selectedQualificationInfo || []
				const sslCode = selectOptions[0]?.code || ''
				// 组件映射表
				const componentMap = {
					// 建筑业
					'107': 'ConstructionEnterpriseMaintenance',
					// 安许
					'109': 'SafetyPermitMaintenance',
					// 工程监理
					'106': 'EngineeringSupervisionMaintenance',
					// 房地产开发
					'111': 'RealEstateDevelopmentMaintenance'
				}

				// 根据sslCode获取对应的组件名，不存在则返回默认组件
				return componentMap[sslCode] || 'SafetyPermitMaintenance'
			},
			// 动态计算所选择的资质个数
			computedSelectionLength() {
				let totalSelected = 0
				this.qualificationGroups.forEach(group => {
					const groupSelected = group.collection.filter(option => option.selected)
					totalSelected += groupSelected.length
				})

				return totalSelected
			}
		},
		watch: {},
		created() {},
		mounted() {
			// 绑定企业查看该企业可重新核定资质
			if (this.isHasCompany) {
				// 默认查询该企业现有资质
				this.handleQueryAllQualification('existing')
			}
		},
		methods: {
			// 添加切换资质类型的方法
			handleSwitchType(type) {
				if (this.qualificationType !== type) {
					this.qualificationType = type
					// 切换类型时重置选中状态
					this.resetSelections()
					// 根据不同类型加载不同的资质数据
					this.handleQueryAllQualification(type)
				}
			},

			// 重置所有选中状态
			resetSelections() {
				this.qualificationGroups.forEach(group => {
					if (group.collection && Array.isArray(group.collection)) {
						group.collection.forEach(item => {
							item.selected = false
						})
					}
				})
				this.selectedCategoryType = null
			},

			// 查询重新核定资质
			handleQueryAllQualification(type) {
				const params = {
					// 资质等级
					dictionaryId: '1',
					// 查询全部资质
					cxType: '2'
				}

				if (type === 'existing') {
					// 查询该企业的现有资质
					params.companyCode = this.companyId
					params.choiceType = 'cxhd'
				} else {
					params.choiceType = 'sc'
				}

				this.qualificationLoading = true

				queryCommonDictionary(params)
					.then(response => {
						this.qualificationLoading = false
						const { data } = response

						if (data && data.length) {
							// 遍历数据给每一个子项添加selected属性
							data.forEach(item => {
								if (item.collection && Array.isArray(item.collection)) {
									item.collection.forEach(subItem => {
										subItem.selected = false
									})
								}
							})

							this.qualificationGroups = data

							// 初始化时检查"资质选择"内容是否溢出
							this.checkContentOverflow()
						}
					})
					.catch(error => {
						this.qualificationLoading = false
					})
			},

			// 切换展开/收起状态
			toggleExpand(index) {
				this.$set(this.expandedGroups, index, !this.expandedGroups[index])
			},

			// 检查内容是否需要展开按钮
			checkContentOverflow() {
				this.$nextTick(() => {
					const containers = this.$refs.optionsContainer
					if (!containers) return

					// 如果是单个元素，转为数组处理
					const containerArray = Array.isArray(containers) ? containers : [containers]

					containerArray.forEach((container, index) => {
						// 获取容器的滚动高度（内容总高度）
						const scrollHeight = container.scrollHeight

						// 如果内容高度大于最大显示高度，则需要显示展开按钮
						this.$set(this.showExpandButtons, index, scrollHeight > this.maxHeight + 10) // 添加10px的缓冲
					})
				})
			},

			// 处理复选框变化
			handleCheckboxChange(checked, categoryName, option) {
				if (checked) {
					// 如果选中，记录当前选中的类型
					this.selectedCategoryType = categoryName
					// 判定是否已选5项
					if (this.computedSelectionLength >= 5) {
						this.$modal.msgWarning('资质诊断一本证书限制只能最多选5项资质，您已满5项！')
					}
				} else {
					// 如果取消选中，检查当前类型下是否还有其他选中项
					const hasSelectedInSameCategory = this.qualificationGroups
						.find(group => group.name === categoryName)
						?.collection.some(opt => opt.selected)
					// 如果没有其他选中项，清空当前选中类型
					if (!hasSelectedInSameCategory) {
						this.selectedCategoryType = null
					}
				}
			},

			// 判断选项是否应该被禁用
			isDisabled(categoryName, option) {
				// 当资质已选5项时，将其余未选择的资质全部禁用掉，不让其选择
				if (!option.selected && this.computedSelectionLength >= 5) {
					return true
				}

				// 如果没有选中任何类型，或者当前选项所属类型就是选中的类型，则不禁用
				if (!this.selectedCategoryType || this.selectedCategoryType === categoryName) {
					return false
				}

				// 其他类型的选项都禁用
				return true
			},

			// 获取所有选择的资质
			handleComputedAllSelection() {
				// 获取所有选中的选项
				const selectedOptions = []
				this.qualificationGroups.forEach(group => {
					const groupSelected = group.collection.filter(option => option.selected)
					if (groupSelected.length > 0) {
						selectedOptions.push({
							groupName: group.name,
							code: group.code,
							collection: groupSelected
						})
					}
				})

				console.log('选中的选项:', selectedOptions)
				this.selectedQualificationInfo = selectedOptions
			},

			// 立即诊断
			async handleDiagnoseImmediately() {
				if (!this.isHasCompany) {
					this.$modal.msgWarning('您尚未绑定企业，请先绑定企业后再进行操作')
					return
				}

				// 判断是否购买会员
				if (this.isNormalVip) {
					this.$modal.msgWarning('您尚未开通会员，请开通会员后进行操作')
					return
				}

				// 前置判断资质诊断权益是否耗尽
				const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.ZZZD)
				if (!isValid) {
					return
				}

				if (this.computedSelectionLength > 5) {
					this.$modal.msgWarning('资质诊断一本证书限制只能最多选5项资质，您已满5项！')
					return
				}

				this.handleComputedAllSelection()
				if (!this.selectedQualificationInfo.length) {
					this.$modal.msgWarning('请选择对应证书的对应资质')
					return
				}
				this.diagnosisVisible = true
			},

			// 提交资质诊断材料、生成资质比对结果
			async handleSubmitMaterials() {
				// 获取当前组件的自维护信息
				const maintenanceInfo = this.$refs.maintenanceInfo
				// 验证对应的资质诊断材料是否维护
				const isSettingValid = maintenanceInfo.handleValidMaintenanceInfoIsSetting()
				if (!isSettingValid) {
					this.$modal.msgWarning('请维护对应资质材料')
					return
				}

				try {
					this.submitLoading = true
					// 执行各类证书材料信息保存
					await maintenanceInfo.saveMaintenanceInfoPromise()
				} catch (error) {
					this.submitLoading = false
				}

				// 取出所有的证书及资质信息
				const qualificationInfoObject = this.selectedQualificationInfo[0]
				// 证书对应的ssl编码
				const sslCode = qualificationInfoObject.code
				// 证书对应名称
				// const zzMc = qualificationInfoObject.groupName
				// 取出选择的资质编码
				const zzCodeArr = qualificationInfoObject.collection.map(item => item.dictcode)
				// 取出资质编码和名称组合成数组
				const zzCodeInfoArr = qualificationInfoObject.collection.map(item => ({
					name: item.dictionaryValues,
					code: item.dictcode
				}))
				console.log('zzCodeArr:', zzCodeArr)

				const params = {
					zzCodeInfo: zzCodeInfoArr,
					zzCode: zzCodeArr.join(','),
					ssl: sslCode,
					mattersType: 'CXHD'
					// zzMc: zzMc
				}

				// 建筑业企业资质提交材料需要将技术负责人作为字段传递
				if (sslCode === '107') {
					const { personnelData, overallDataForm } = maintenanceInfo
					params.jsfzrPersonList = JSON.stringify(personnelData.jsfzr)
					params.netAsset = overallDataForm.netAsset

					// 判断当前所选的资质类别对应的技术负责人是否有值
					const jsfzrData = maintenanceInfo.personnelData.jsfzr

					const missing = zzCodeArr.filter(code => !jsfzrData.some(item => item.zzCode === code))

					if (missing.length > 0) {
						// missing编码转换为名称
						const missingName = missing.map(
							code => qualificationInfoObject.collection.find(item => item.dictcode === code).dictionaryValues
						)
						const missingStr = missingName.join('、')
						this.$modal.msgWarning(`【${missingStr}】未维护对应的技术负责人，请补充后再提交`)
						return
					}
				}

				try {
					this.submitLoading = true
					await generateDiagnosticResults(params)
					this.diagnosisVisible = false
					this.$modal.msgSuccess('操作成功')
					// 诊断材料提交诊断成功后，刷新一次诊断记录
					this.$refs.diagnosticRecords.handleQueryDiagnosisRecordList()
				} catch (error) {
					this.submitLoading = false
				} finally {
					this.submitLoading = false
				}
			},

			// 关闭诊断材料提交
			handleCloseDiagnosis() {
				this.diagnosisVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';
	@import './styles/diagnosis.scss';
</style>
